{
  "name": "ms-cockpit",
  "version": "1.4.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "lint": "eslint src"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.26",
    "@angular/cdk": "^20.2.4",
    "@angular/common": "^20.3.26",
    "@angular/compiler": "^20.3.26",
    "@angular/core": "^20.3.26",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.26",
    "@angular/localize": "^20.3.26",
    "@angular/material": "^20.2.4",
    "@angular/platform-browser": "^20.3.26",
    "@angular/platform-browser-dynamic": "^20.3.26",
    "@angular/router": "^20.3.26",
    "@icure/api": "8.8.7",
    "@ngxs/devtools-plugin": "^20",
    "@ngxs/form-plugin": "^20",
    "@ngxs/hmr-plugin": "^20",
    "@ngxs/logger-plugin": "^20",
    "@ngxs/router-plugin": "^20",
    "@ngxs/store": "^20",
    "bootstrap": "5.0.0",
    "chart.js": "^4.5.1",
    "font-awesome": "^4.7.0",
    "lodash": "^4.17.21",
    "rxjs": "^7.8.2",
    "tslib": "^2.3.0",
    "uuid": "^12.0.0",
    "whatwg-fetch": "^3.0.0",
    "xlsx": "^0.18.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^20.3.0",
    "@angular-eslint/eslint-plugin-template": "^20.3.0",
    "@angular-eslint/template-parser": "^20.3.0",
    "@angular/build": "^20.3.2",
    "@angular/cli": "~20.3.2",
    "@angular/compiler-cli": "^20.3.26",
    "@eslint/js": "^9.35.0",
    "@types/crypto-js": "^4.1.1",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.14.189",
    "@types/node": "18.19.9",
    "baseline-browser-mapping": "^2.10.38",
    "eslint": "^9.35.0",
    "jest": "^30.4.2",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^17.0.0",
    "ts-jest": "^29.4.11",
    "typescript": "^5.9.2",
    "typescript-eslint": "^8.41.0"
  },
  "allowScripts": {
    "@parcel/watcher@2.5.1": true,
    "esbuild@0.25.9": true,
    "fsevents@2.3.3": true,
    "lmdb@3.4.2": true,
    "msgpackr-extract@3.0.3": true,
    "esbuild@0.28.1": true,
    "unrs-resolver@1.12.2": true
  }
}
